<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="
                md-raised md-primary md-button-color md-theme-default
                back
                heght-1px
              "
              @click="previousPage"
              >&laquo; Back</md-button
            >
          </md-layout>
          <md-layout md-flex="30"></md-layout>
          <md-layout md-flex="40">
            <h2>Sail and FPOD Detail</h2>
          </md-layout>
        </md-layout>

        <hr class="hr-s" />

        <div class="phone-viewport" id="vehicleBooking">
          <md-list>
            <md-list-item
              id="showvehicleBooking"
              class="md-button-color-toggle"
              v-bind:class="sailVModel.conFclSailId == '' ? 'md-active' : ''"
            >
              <span>Sail Details</span>

              <md-list-expand>
                <md-list>
                  <!-- <div v-if="getContainerSail.length>0 || sailVModel.ffSailId!=''"> -->
                  <div>
                    <hr class="hr-border" />
                    <md-layout gutter class="labelMargtop">
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="25">
                        <label for="isBookingtranshipment"
                          >Booking transhipment</label
                        >
                        <model-list-select
                          :list="bookingtranshipmentList"
                          v-model="sailVModel.isBookingtranshipment"
                          :isDisabled="
                            tentativeDetailArrayList.length > 0 ? true : false
                          "
                          option-value="bookingtranshipmentVal"
                          option-text="bookingtranshipmentText"
                          placeholder="Select Booking transhipment"
                        ></model-list-select>
                        <span
                          class="error"
                          v-if="!sailVModel.isBookingtranshipment"
                          >{{ SailerrorList.isBookingtranshipment }}</span
                        >
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="25">
                        <md-layout md-flex="100">
                          <label>Container Number</label>
                          <b-form-input
                            :formatter="capitalizeAll"
                            disabled
                            v-model="sailVModel.containerNo"
                          ></b-form-input>
                        </md-layout>
                        <span class="error" v-if="!sailVModel.containerNo">{{
                          SailerrorList.containerNo
                        }}</span>
                      </md-layout>
                    </md-layout>

                    <div v-if="sailVModel.isBookingtranshipment == 'yes'">
                      <hr class="hr-border" />
                      <md-layout md-gutter>
                        <md-layout md-flex="5"></md-layout>
                        <h4>
                          <u>
                            Transhipment Details
                            <span
                              v-if="tentativeDetailArray.length == 0"
                              class="error"
                              >{{ atleastOneTentative }}</span
                            >
                          </u>
                        </h4>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="25">
                          <label for="tentativePortId"
                            >Tentative Port Name</label
                          >
                          <model-list-select
                            option-value="pickupId"
                            option-text="pickupLocation"
                            :list="locationList"
                            placeholder="Select Port Name"
                            v-model="transhipment.tentativePortId"
                          ></model-list-select>
                          <span class="error" v-if="!transhipment.etdTime">{{
                            TranshiperrorList.tentativePortId
                          }}</span>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="20">
                          <label>ETA Date</label>

                          <date-picker
                            lang="en"
                            v-model="transhipment.etaDate"
                            type="datetime"
                            format="YYYY-MM-DD hh:mm "
                            :minute-step="1"
                            id="etaDate"
                          ></date-picker>
                          <span class="error" v-if="!transhipment.etdTime">{{
                            TranshiperrorList.etdTime
                          }}</span>
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="20">
                          <label>ETD Date</label>
                          <date-picker
                            lang="en"
                            v-model="transhipment.etdDate"
                            type="datetime"
                            format="YYYY-MM-DD hh:mm "
                            :minute-step="1"
                            id="etdDate"
                          ></date-picker>
                          <span class="error" v-if="!transhipment.etdTime">{{
                            TranshiperrorList.etdTime
                          }}</span>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="25">
                          <md-layout md-flex="100">
                            <label>Vessel Name</label>
                            <b-form-input
                              :formatter="capitalizeAll"
                              id="transvesselName"
                              name="transvesselName"
                              v-model="transhipment.vesselName"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="20">
                          <md-layout md-flex="100">
                            <label>Container No</label>
                            <b-form-input
                              :formatter="capitalizeAll"
                              id="transcontainerNo"
                              name="transcontainerNo"
                              v-model="transhipment.containerNo"
                              disabled
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="15">
                          <md-button
                            class="
                              md-raised
                              md-primary
                              md-button-color
                              md-theme-default
                              back
                              heght-1px
                            "
                            @click="addTentativeDetail"
                            id="addButtonLoader222"
                            >{{
                              editIndex == "" &&
                              (editIndex != "0" || editIndex != 0) &&
                              transhipment.conSailTranshipmentId == ""
                                ? "Add"
                                : "Edit"
                            }}
                            T/S</md-button
                          >

                          <md-spinner
                            md-indeterminate
                            id="loader222"
                            style="display: none"
                          ></md-spinner>
                        </md-layout>
                      </md-layout>
                    </div>
                    <hr
                      class="hr-border"
                      v-if="
                        tentativeDetailArrayList.length > 0 ||
                        showMoreNew == true
                      "
                    />
                    <div class="box" v-if="tentativeDetailArrayList.length > 0">
                      <div class="box-header">
                        <h3 class="box-title">
                          <u>Transhipment Details</u>
                        </h3>
                      </div>
                      <hr class="hr-s" />
                      <!-- /.box-header -->
                      <div class="box-body">
                        <table
                          id="poTablefdfdf"
                          class="table table-bordered table-striped"
                        >
                          <thead>
                            <tr>
                              <th>Sr No.</th>
                              <th>Tentative Port Name</th>
                              <th>Arrival Time</th>
                              <th>Departure Time</th>
                              <th>Edit</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(item, index) in tentativeDetailArrayList"
                              :key="index"
                            >
                              <td>{{ index + 1 }}</td>
                              <td>{{ item.tentativePortName }}</td>
                              <td>{{ item.etaDate }}</td>
                              <td>{{ item.etdDate }}</td>

                              <td>
                                <md-button
                                  class="md-icon-button md-raised md-dense"
                                  @click="
                                    viewEdit(item.conSailTranshipmentId, index)
                                  "
                                >
                                  <md-icon>edit</md-icon>
                                </md-button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- /.box-body -->
                    </div>

                    <hr class="hr-border" />

                    <md-layout gutter class="labelMargtop">
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="25">
                        <md-layout md-flex="100">
                          <label>Vessel Name</label>
                          <b-form-input
                            :formatter="capitalizeAll"
                            id="vesselName"
                            name="vesselName"
                            v-model="sailVModel.vesselName"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="25">
                        <md-layout md-flex="100">
                          <label>Voyage Name</label>
                          <b-form-input
                            :formatter="capitalizeAll"
                            id="voyageName"
                            name="voyageName"
                            v-model="sailVModel.voyageName"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="25">
                        <md-layout md-flex="100">
                          <label>Rotation No.</label>
                          <b-form-input
                            :formatter="capitalizeAll"
                            id="rotationNo"
                            name="rotationNo"
                            v-model="sailVModel.rotationNo"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>
                    </md-layout>

                    <md-layout gutter class="labelMargtop">
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="20">
                        <label>Date of Loading of Vessel</label>

                        <date-picker
                          lang="en"
                          v-model="sailVModel.vesselLoadingDate"
                          type="date"
                          format="YYYY-MM-DD"
                          id="vesselLoadingDate"
                          :minute-step="1"
                        ></date-picker>
                      </md-layout>

                      <md-layout md-flex="10"></md-layout>
                      <md-layout md-flex="20">
                        <label>Date of Departure</label>

                        <date-picker
                          lang="en"
                          v-model="sailVModel.dateOfDeparture"
                          type="date"
                          format="YYYY-MM-DD "
                          id="dateOfDeparture"
                          :minute-step="1"
                        ></date-picker>
                      </md-layout>
                      <md-layout md-flex="10"></md-layout>
                      <md-layout md-flex="25">
                        <label>Date of Arrival of Delivery Port</label>
                        <date-picker
                          lang="en"
                          v-model="sailVModel.deliveryPortArrDate"
                          type="date"
                          format="YYYY-MM-DD "
                          id="deliveryPortArrDate"
                          :minute-step="1"
                        ></date-picker>
                      </md-layout>
                    </md-layout>

                    <md-layout gutter class="labelMargtop"></md-layout>
                    <hr class="hr-s" />
                    <md-layout md-gutter class="mrgtop-button">
                      <md-layout md-flex="40"></md-layout>
                      <md-layout md-flex="40">
                        <md-button
                          class="
                            md-raised md-primary md-button-color
                            heght-1px
                            mrgtop-2per
                          "
                          id="addButtonLoader1"
                          style="z-index: 0"
                          @click="addSail"
                          >{{
                            sailVModel.conFclSailId == "" ? "Add" : "Edit"
                          }}
                          Sail Detail</md-button
                        >
                        <md-spinner
                          md-indeterminate
                          id="loader1"
                          style="display: none"
                        ></md-spinner>
                      </md-layout>
                    </md-layout>
                  </div>

                  <hr class="hr-s" />
                </md-list>
              </md-list-expand>
            </md-list-item>
          </md-list>
        </div>

        <hr class="hr-s" />
        <!-- <div class="phone-viewport" id="vehicleBooking" v-if="getContainerSail.length==0"> -->
        <div
          class="phone-viewport"
          id="vehicleBooking"
          v-if="sailVModel.conFclSailId != ''"
        >
          <md-list>
            <md-list-item
              id="showvehicleBooking"
              class="md-button-color-toggle md-active"
            >
              <span>FINAL DELIVERY DETAILS for FF Assignment Closure</span>

              <md-list-expand>
                <md-list>
                  <!-- <div
                    v-if="containerNoFPODList.length>0 || finalDeliveryModel.fffpodContainerId!=''"
                  >-->
                  <div>
                    <hr class="hr-border" />

                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="30">
                        <md-layout md-flex="100">
                          <label for="containerNo">Container No</label>
                          <b-form-input
                            :formatter="capitalizeAll"
                            v-model="finalDeliveryModel.containerNo"
                            disabled
                          ></b-form-input>
                        </md-layout>
                        <span
                          class="error"
                          v-if="!finalDeliveryModel.containerNo"
                          >{{ FPODerrorList.containerNo }}</span
                        >
                      </md-layout>
                    </md-layout>
                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="35">
                        <label for="podLocationId">Place of Delivery</label>
                        <model-list-select
                          @input="
                            getLocationList($event, 'All', 'getlocationListData')
                          "
                          @searchchange="
                            getLocationList($event, 'All', 'getlocationListData')
                          "
                          option-value="pickupId"
                          option-text="pickupLocation"
                          :list="locationList"
                          placeholder="Select POD Location"
                          v-model="finalDeliveryModel.podLocationId"
                        ></model-list-select>
                        <span
                          class="error"
                          v-if="!finalDeliveryModel.podLocationId"
                          >{{ FPODerrorList.podLocationId }}</span
                        >
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="35">
                        <label for="FpodLocationId"
                          >Final Place of Delivery</label
                        >
                        <model-list-select
                          option-value="pickupId"
                          option-text="pickupLocation"
                          :list="locationList"
                          placeholder="Select FPOD Location"
                          v-model="finalDeliveryModel.FpodLocationId"
                        ></model-list-select>
                        <span
                          class="error"
                          v-if="!finalDeliveryModel.FpodLocationId"
                          >{{ FPODerrorList.FpodLocationId }}</span
                        >
                      </md-layout>
                    </md-layout>

                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="20">
                        <label>Enter Gate In Date</label>
                        <date-picker
                          lang="en"
                          v-model="finalDeliveryModel.gateInDate"
                          id="date"
                        ></date-picker>
                      </md-layout>
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="20">
                        <label>Enter Gate Out Date</label>
                        <date-picker
                          lang="en"
                          v-model="finalDeliveryModel.gateOutDate"
                          id="date"
                        ></date-picker>
                        <!-- <date-picker
              lang="en"
              v-model="sailVModel.trainDepartDate"
               
              id="date"
              
                        ></date-picker>-->
                      </md-layout>
                      <md-layout md-flex="10"></md-layout>
                      <md-layout md-flex="20">
                        <label>Final Delivery Date</label>
                        <date-picker
                          lang="en"
                          v-model="finalDeliveryModel.finalDeliveryDate"
                          id="date"
                        ></date-picker>
                      </md-layout>
                    </md-layout>
                    <hr class="hr-border" />
                    <md-layout md-gutter class="mrgtop-button">
                      <md-layout md-flex="40"></md-layout>
                      <md-button
                        class="
                          md-raised md-primary md-button-color
                          heght-1px
                          mrgtop-2per
                        "
                        id="addButtonLoader1111"
                        @click="addFpod"
                        >Submit</md-button
                      >
                      <md-spinner
                        md-indeterminate
                        id="loader1111"
                        style="display: none"
                      ></md-spinner>
                    </md-layout>
                  </div>
                </md-list>
              </md-list-expand>
            </md-list-item>
          </md-list>
        </div>
      </md-card-content>
    </md-card>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPopSail"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop22"
      @close="onClose22"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop11212"
      @close="onClose11212"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPopData"
    ></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE } from "../../helper/constant.js";
import {
  globalPermissionStatus,
  GlobalGetLocation,
} from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Sea Freight")) {
      this.$store.dispatch("setCurrentRoute", "/ffExportCon/consoFclSailFpod");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {},
  data() {
    return {
      isLoading: false,
      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },
      autoClientName: {},
      showMoreNew: false,
      transhipmentContainer: "",
      sailVModel: {
        conFclSailId: "",
        conSailTranshipmentId: "",
        containerNo: "",
        ffExecutionContainerId: "",
        ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        conFclBookingId: this.$sessionsStorage.get("editconFclBookingId"),
        ffConExecutionId: this.$sessionsStorage.get("editffConExecutionId"),

        shippingId: "",
        vesselLoadingDate: "",
        vesselName: "",
        deliveryPortArrDate: "",
        dateOfDeparture: "",
        rotationNo: "",
        voyageName: "",
        isBookingtranshipment: "",
      },

      removesailVModel: {
        containerNo: "",
        ffExecutionContainerId: "",
        ffSailId: "",
      },

      transhipment: {
        conSailTranshipmentId: "",
        conFclSailId: "",
        tentativePortId: "",
        tentativePortName: "",
        vesselName: "",
        containerNo: "",
        etaDate: "",
        etdDate: "",
      },
      finalDeliveryModel: {
        ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        conFclBookingId: this.$sessionsStorage.get("editconFclBookingId"),
        ffConExecutionId: this.$sessionsStorage.get("editffConExecutionId"),
        conFclfpodId: "",
        containerNo: "",
        ffExecutionContainerId: "",
        podLocationId: "",
        FpodLocationId: "",
        finalDeliveryDate: "",
        gateInDate: "",
        gateOutDate: "",
        fffpodContainerId: "",
      },
      removefinalDeliveryModel: {
        containerNo: "",
        ffExecutionContainerId: "",
        fffpodContainerId: "",
      },
      finalDeliveryMain: {
        fffpodId: "",

        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId"),
      },
      transhipmentArray: [],
      fpodTableArray: [],
      getPortData: ["Agra"],
      // clientName: "",
      // vehicleName: "",
      // driverId: "",
      // driverName: "",
      // driverContact: "",
      // driverWorkingYear: "",
      // driverEsic: "",
      // accountNo: "",
      // uploadDriverDoc: ""
      error: {
        clientNameError: "",
        toPortError: "",
        fromPortError: "",
        transhipmentNameError: "",
        addOneTranError: "",
      },

      getCLientData: ["gfdg"],
      showSegmentArray: [],
      driverNameDetail: ["iji"],
      editVar: {
        Inputval:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "New",
      },
      commodityListName: [],
      getContainerSail: [],
      getExectionContainerData: [],
      getSailData: ["abc"],
      getlocationListData: ["agra"],
      validate: true,
      bookingtranshipmentName: [
        {
          bookingtranshipmentVal: "yes",
          bookingtranshipmentText: "Yes",
        },
        {
          bookingtranshipmentVal: "no",
          bookingtranshipmentText: "No",
        },
      ],
      containerforFPODDetail: [],

      TranshiperrorList: {
        tentativePortId: "",
        etaDate: "",

        etdDate: "",
      },
      arrayError: [
        "Enter your tentative port Name",
        "Select ETA Date",
        "Select ETA time",
        "Select ETA Date",
        "Select ETD time",
      ],
      FPODerrorList: {
        containerNo: "",
        podLocationId: "",
        FpodLocationId: "",
      },
      FPODError: [
        "Select container No",
        "Select Place od delivery",
        "Select Final Place of delivery",
      ],
      SailError: ["Select Container Number", "Select Booking Transhipment"],
      SailerrorList: {
        containerNo: "",
        isBookingtranshipment: "",
      },
      atleastOneTentative: "",

      validateTrans: true,
      tentativeDetailArray: [],
      editIndex: "",
      viewAllSail: [],
      viewAllTentative: [],
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
  },
  computed: {
    fpodTableArrayList() {
      return this.fpodTableArray;
    },
    tentativeDetailArrayList() {
      return this.tentativeDetailArray;
    },
    viewAllSailList() {
      return this.viewAllSail;
    },

    containerSailList() {
      return this.getContainerSail;
    },
    locationList() {
      return this.getlocationListData;
    },
    PortList() {
      return this.getPortData;
    },
    viewDocument() {
      return this.sailVModel.uploadDriverDoc.split(",");
    },
    bookingtranshipmentList() {
      return this.bookingtranshipmentName;
    },

    containerNoFPODList() {
      return this.containerforFPODDetail;
    },
  },
  methods: {
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };

      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    showMoreContainer() {
      if (this.showMoreNew == false) {
        this.showMoreNew = true;
      } else {
        this.showMoreNew = false;
      }
    },
    viewEdit(id, index) {
      if (id == "") {
        this.editIndex = index;
        Object.keys(this.transhipment).map((x) => {
          this.transhipment[x] = this.tentativeDetailArray[index][x];
        });
      } else {
        let array = this.tentativeDetailArray.filter((x) => {
          return x.conSailTranshipmentId == id;
        });

        Object.keys(this.transhipment).map((x) => {
          this.transhipment[x] = array[0][x];
        });
      }
      // this.tentativePortNameFull = this.portMasterList.filter(x => {
      //   return x.pickupId == this.TranshipmentDetail.tentativePortId;
      // })[0];
    },
    validatetranshipment() {
      let validate_new = true;
      Object.keys(this.TranshiperrorList).map((x, index) => {
        if (this.transhipment[x] == "") {
          this.TranshiperrorList[x] = this.arrayError[index];
          validate_new = false;
        }
      });

      if (validate_new == false) {
        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },
    addTentativeDetail() {
      let array_new = this.getlocationListData;

      this.transhipment["ffFclConsoExportId"] = this.$sessionsStorage.get(
        "editffFclConsoExportId"
      );
      this.transhipment["ffConExecutionId"] = this.$sessionsStorage.get(
        "editffConExecutionId"
      );

      var obj = {};
      this.validatetranshipment();

      if (this.sailVModel.conFclSailId == "") {
        if (this.validateTrans != false) {
          let arrayPort = array_new.filter((x) => {
            return x.pickupId == this.transhipment.tentativePortId;
          })[0];
          this.transhipment.tentativePortName = arrayPort.pickupLocation;

          $("#addButtonLoader222").css("display", "none");
          $("#loader222").css("display", "block");
          var obj1 = {};
          Object.keys(this.transhipment).map((x) => {
            obj1[x] = this.transhipment[x];
            // this.transhipment.tentativePortId = "";
            // this.transhipment.tentativePortName = "";
            // this.transhipment.vesselName = "";
            // this.transhipment.etaDate = "";
            // this.transhipment.etdDate = "";
          });
          Object.keys(this.TranshiperrorList).map((x) => {
            this.TranshiperrorList[x] = "";
          });

          if (
            this.editIndex == "" &&
            (this.editIndex != "0" || this.editIndex != 0)
          ) {
            this.alert.content = "Data Added Successfully";
            // this.$refs["addPop"].open();

            this.tentativeDetailArray.push(obj1);
          } else {
            this.alert.content = "Data Updated Successfully";
            this.$refs["addPop"].open();
            this.tentativeDetailArray.splice(this.editIndex, 1);
            this.tentativeDetailArray.splice(this.editIndex, 0, obj1);
            this.editIndex = "";
          }
          setTimeout(function () {
            //  this.tentativePortNameFull = {};
            $("#addButtonLoader222").css("display", "block");
            $("#loader222").css("display", "none");
          }, 1000);
        }
      } else {
        this.transhipment["conFclSailId"] = this.sailVModel.conFclSailId;

        if (this.validateTrans != false) {
          let arrayPort = array_new.filter((x) => {
            return x.pickupId == this.transhipment.tentativePortId;
          })[0];
          this.transhipment.tentativePortName = arrayPort.pickupLocation;

          $("#addButtonLoader222").css("display", "none");
          $("#loader222").css("display", "block");
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_FFSeaExport/addConsoFclSailTranshipment.php`,
            data: JSON.stringify(this.transhipment),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              //  console.log(result);
              if (status == 200 && data) {
                if (data.msg == "Inserted Successfully") {
                  Object.keys(this.transhipment).map((x) => {
                    obj[x] = this.transhipment[x];
                    this.transhipment[x] = "";
                  });
                  Object.keys(this.TranshiperrorList).map((x) => {
                    this.TranshiperrorList[x] = "";
                  });
                  obj["conSailTranshipmentId"] = data.conSailTranshipmentId;

                  this.tentativeDetailArray.push(obj);

                  this.alert.content = "Data Added Successfully";

                  this.transhipment.containerNo = this.sailVModel.containerNo;

                  // this.$refs["addPop"].open();
                } else {
                  Object.keys(this.transhipment).map((x) => {
                    this.transhipment[x] = "";
                  });

                  this.transhipment.containerNo = this.sailVModel.containerNo;
                  Object.keys(this.TranshiperrorList).map((x) => {
                    this.TranshiperrorList[x] = "";
                  });
                  this.alert.content = "Data Updated Successfully";
                  this.$refs["addPop"].open();
                }

                setTimeout(function () {
                  //this.tentativePortNameFull = {};
                  $("#addButtonLoader222").css("display", "block");
                  $("#loader222").css("display", "none");
                }, 1000);

                this.getData();
                // // $("#loader11212").css("display", "none");
                // // $("#addButtonLoader11212").css("display", "block");
                // this.$refs["addPop11212"].open();
              }
            })
            .catch((error) => {});
        }
      }
    },

    editFPODDetail(item) {
      Object.keys(this.finalDeliveryModel).map((x) => {
        this.finalDeliveryModel[x] = item[x] || "";
      });
    },
    validateaddSail() {
      let validate_new = true;

      Object.keys(this.SailerrorList).map((x, index) => {
        if (this.sailVModel[x] == "") {
          this.SailerrorList[x] = this.SailError[index];
          validate_new = false;
        }
      });

      if (
        this.tentativeDetailArray.length == 0 &&
        this.sailVModel.isBookingtranshipment == "yes"
      ) {
        this.atleastOneTentative = "Select Atleast one Transhipment";
        validate_new = false;
      } else {
        this.atleastOneTentative;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    addSail() {
      this.sailVModel["transhipment"] = this.tentativeDetailArray;
      this.validateaddSail();

      if (this.validate != false) {
        $("#addButtonLoader1").css("display", "none");
        $("#loader1").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addConsoFclSail.php`,
          data: JSON.stringify(this.sailVModel),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            //  console.log(result);
            if (status == 200 && data) {
              $("#loader1").css("display", "none");
              $("#addButtonLoader1").css("display", "block");

              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }
              // this.$sessionsStorage.set(
              //   "editconFclSailId",
              //   data.conFclSailId
              // );
              this.$refs["addPopSail"].open();

              this.getData();
              Object.keys(this.removesailVModel).map((x) => {
                this.sailVModel[x] = "";
              });
              // this.tentativeDetailArray = [];
            }
          })
          .catch((error) => {});
      }
    },
    validateFPOD() {
      let validate_new = true;

      Object.keys(this.FPODerrorList).map((x, index) => {
        if (this.finalDeliveryModel[x] == "") {
          this.FPODerrorList[x] = this.FPODError[index];

          validate_new = false;
        }
      });

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    addFpod() {
      this.validateFPOD();
      if (this.validate != false) {
        $("#addButtonLoader1111").css("display", "none");
        $("#loader1111").css("display", "block");

        // console.log(this.handover);
        // return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addFclConsoFPOD.php`,
          data: JSON.stringify(this.finalDeliveryModel),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            //  console.log(result);
            if (status == 200 && data) {
              $("#loader1111").css("display", "none");
              $("#addButtonLoader1111").css("display", "block");
              if (this.finalDeliveryModel.conFclfpodId == "") {
                this.alert.content = "Data Added Succesfully";
              } else {
                this.alert.content = "Data Updated Succesfully";
              }
              //  this.$sessionsStorage.set(
              //   "editconFclfpodId",
              //   data.conFclfpodId
              // );
              this.$refs["addPopData"].open();
              this.getData();
            }
          })
          .catch((error) => {});
      }
    },
    // addFpodTables() {
    //   if (
    //     this.containerforFPODDetail.length > 0 &&
    //     this.finalDeliveryModel.fffpodContainerId == ""
    //   ) {
    //     let newArray = this.containerforFPODDetail.filter(x => {
    //       return (
    //         x.ffExecutionContainerId ==
    //         this.finalDeliveryModel.ffExecutionContainerId
    //       );
    //     });

    //     if (newArray.length > 0) {
    //       this.finalDeliveryModel.containerNo = newArray[0].containerNo;
    //     }
    //   }

    //   let new_data = {
    //     finalDeliveryMain: this.finalDeliveryMain,
    //     finalDeliveryModel: this.finalDeliveryModel
    //   };

    //   this.validateFPOD();

    //   if (this.validate != false) {
    //     let options = {
    //       method: "POST",
    //       url: `${URL_BASE}/Api_FFSeaExport/addFinalPlaceDelivery.php`,
    //       data: JSON.stringify(new_data),
    //       crossDomain: true,
    //       headers: {
    //         Accept: "application/json",
    //         "Content-Type": "application/json",
    //         Authorization: this.$sessionsStorage.get("loginId")
    //       }
    //     };
    //     axios(options)
    //       .then(result => {
    //         const { statusText, status, data } = result;
    //         if ( status == 200 && data) {
    //           this.finalDeliveryMain.fffpodId = data.fffpodId;

    //           if (this.finalDeliveryModel.fffpodContainerId != "") {
    //             this.alert.content = " Data Updated Succesfully";
    //           } else {
    //             this.alert.content = " Data Added Succesfully";
    //           }
    //           // console.log(this.railoutMain.ffRailOutId, "fsdfdf");

    //           Object.keys(this.finalDeliveryModel).map(x => {
    //             this.finalDeliveryModel[x] = "";
    //           });
    //           Object.keys(this.FPODError).map(x => {
    //             this.FPODError[x] = "";
    //           });

    //           // this.$refs["addPop22"].open();
    //           this.getData();
    //         }
    //       })
    //       .catch(error => {});
    //   }
    // },
    // // getClientData1(item) {
    // //   this.sailVModel.clientId = item.clientId;
    // //  // console.log(item)
    // // },\

    viewEditSail(item) {
      Object.keys(this.sailVModel).map((x) => {
        this.sailVModel[x] = item[x];
      });

      let array = this.viewAllTentative.filter((x) => {
        return x.ffSailId == item.ffSailId;
      });
      this.tentativeDetailArray = array;
      // Object.keys(this.transhipment).map(x => {
      //   this.transhipment[x] = array[0][x];
      // });
    },
    getPortId1(item) {
      this.sailVModel.toportId = item.portId;
    },
    getPortId2(item) {
      this.sailVModel.fromportId = item.portId;
    },
    getPortId3(item) {
      this.transhipment.tentportId = item.portId;
    },

    //    JqueryFun() {
    //   return $(function() {
    //     return $("#poTablefdfdf").DataTable();
    //   });
    // },
    clientFilter(list, query) {
      return this.getCLientData.filter((x) => {
        return x.clientName.toLowerCase().includes(query.toLowerCase());
      });
    },
    PortFilter(list, query) {
      return this.getPortData.filter((x) => {
        return x.portName.toLowerCase().includes(query.toLowerCase());
      });
    },
    valis() {
      let validate_new = true;

      Object.keys(this.FPODerrorList).map((x, index) => {
        if (this.finalDeliveryModel[x] == "") {
          this.FPODerrorList[x] = this.FPODError[index];
          validate_new = false;
        }
      });

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    onClose11212() {},

    getData() {
      this.doLoading();
      let vehicle_drive = {
        itemCode: "itemCode",
        ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        conFclBookingId: this.$sessionsStorage.get("editconFclBookingId"),
        ffConExecutionId: this.$sessionsStorage.get("editffConExecutionId"),
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/fetchConsoFCLSail.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data, "sasasasajitu");

            if (data.clientdetail.length > 0) {
              this.getCLientData = data.clientdetail;
            } else {
              this.getCLientData = [];
            }
            if (data.LocationDetails.length > 0) {
              this.getlocationListData = data.LocationDetails;
            } else {
              this.getlocationListData = [];
            }
            if (data.FullwhExecData.length > 0) {
              this.getExectionContainerData = data.FullwhExecData;
              let arrayContainer = this.getExectionContainerData.filter((x) => {
                return x.ffConExecutionId;
              })[0];
              this.sailVModel.containerNo = arrayContainer.fclConcontainerNo;
              this.transhipment.containerNo = arrayContainer.fclConcontainerNo;
              this.finalDeliveryModel.containerNo =
                arrayContainer.fclConcontainerNo;
            } else {
              this.getExectionContainerData = [];
            }

            // this.getShippingLineData = data.slineDetails

            if (data.viewAllSailTrans.length > 0) {
              this.viewAllTentative = data.viewAllSailTrans;
            }

            if (data.viewEditSailDetails.length > 0) {
              Object.keys(data.viewEditSailDetails[0]).map((x) => {
                this.sailVModel[x] = data.viewEditSailDetails[0][x] || "";
              });
            }

            if (data.FPODDetail.length > 0) {
              Object.keys(data.FPODDetail[0]).map((x) => {
                this.finalDeliveryModel[x] = data.FPODDetail[0][x] || "";
              });
            }

            console.log(data.FPODDetail, "hgjh");

            if (this.sailVModel.ffSailId != "") {
              let array = this.viewAllTentative.filter((x) => {
                return x.ffSailId == this.sailVModel.ffSailId;
              });
              this.tentativeDetailArray = array;
            }
            //this.JqueryFun();
            this.doLoadingClose();
          }
        })
        .catch((error) => {});
    },

    onClose22() {},

    previousPage() {
      this.$router.push({
        path: "/ffExportCon/fclConsoHandOverToRail",
      });
    },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// consoFclSailFpod.vue?1462fa0d